export default __webpack_public_path__ + "static/media/2005.63a14aed.png";